<template>
  <div>
    <CardInformasiGudang :warehouse-id="warehouse_id" />
    <CardFasilitasGudang
      :warehouse-id="warehouse_id"
      @update:facilities="updateFacilities"
      @updated:facilities-cost="updateFacilitiesCost"
    />
    <CardBiayaGudang
      ref="cardBiayaGudang"
      :warehouse-id="warehouse_id"
      :facilities="facilities"
    />
  </div>
</template>

<script>
import provider from '@/provider/provider'
import { SETTING_PROFILE } from '@/provider/url'
import { toastError } from '@/libs/toastification'
import CardInformasiGudang from './components/CardInformasiGudang.vue'
import CardFasilitasGudang from './components/CardFasilitasGudang.vue'
import CardBiayaGudang from './components/CardBiayaGudang.vue'

export default {
  components: {
    CardInformasiGudang,
    CardFasilitasGudang,
    CardBiayaGudang,
  },
  data() {
    return {
      mitra_id: this?.$store?.state?.auth?.userData?.mitras?.id,
      user_id: this?.$store?.state?.auth?.userData?.id,
      warehouse_id: -1,
      facilities: [],
    }
  },
  created() {
    this.fetchDetailMitra()
  },
  methods: {
    /**
     * Fetch detail mitra to get warehouse id
     */
    fetchDetailMitra() {
      provider.list(`${SETTING_PROFILE}?user_id=${this.user_id}`)
        .then(({ data }) => {
          this.warehouse_id = data.warehouse.id
        })
        .catch(() => {
          toastError('Gagal mengambil data informasi gudang, silahkan refresh untuk coba lagi')
        })
    },
    updateFacilities(facilities) {
      this.facilities = facilities
    },
    updateFacilitiesCost() {
      this.$refs.cardBiayaGudang.fetchWarehouseCost()
    },
  },
}
</script>
